import { render, staticRenderFns } from "./SubjectUpdate.vue?vue&type=template&id=45052196&"
import script from "./SubjectUpdate.vue?vue&type=script&lang=js&"
export * from "./SubjectUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports